import { render, staticRenderFns } from "./ConfigEdit.vue?vue&type=template&id=4b33dd15&scoped=true"
import script from "./ConfigEdit.vue?vue&type=script&lang=js"
export * from "./ConfigEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b33dd15",
  null
  
)

export default component.exports